import styled from 'styled-components';
import { Text, Radio } from '@movember/mo-gel';

export const StyledSelectContainer = styled.div`
    input[name="ltc_noOtherHealthConditions"], input[name="ltc_noOtherHealthConditions"] + label {
        transform: translateY(20px);
    }

    & > div {
        /* Left align the Select */
        text-align: left;

        & > div {
            /* set select list width to fit content width */
            width: fit-content;
        }
    }
`;

export const StyledHeadingContainer = styled.div`
    padding: 0 0rem;
    margin-bottom: 1rem;

    @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
        width: 410px;
        margin-bottom: 2.1875rem;
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
        width: 460px;
        margin-bottom: 2.13125rem;
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
        width: 616px;
        margin-bottom: 1.3125rem;
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints.xl}) {
        width: 675px;
        margin-bottom: 2.7875rem;
    }
`;

export const StyledHeading = styled(Text)`
    font-size: 1.15rem;
    font-weight: bold;
    line-height: 1.38125rem;

    @media screen and (min-width: ${(props) => props.theme.breakpoints.sm}) {
        font-size: 1.275rem;
        line-height: 1.53125rem;
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints.md}) {
        font-size: 1.35rem;
        line-height: 1.61875rem;
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints.lg}) {
        font-size: 1.5rem;
        line-height: 1.8rem;
    }

    @media screen and (min-width: ${(props) => props.theme.breakpoints.xl}) {
        font-size: 1.65rem;
        line-height: 1.98125rem;
        letter-spacing: -0.25px;
    }
`;

export const StyledRadio = styled(Radio)`
    width: fit-content;
`;